import React from 'react';
import { useLocation } from 'react-router-dom';

import Page from '../../components/Page';

import { getSidebarActions } from '../../sections/employee/applications/ApplicationsSidebar';
import TableView from '../../sections/employee/generics/TableView';
import { getDataGridProps } from '../../sections/employee/applications/DatagridProps';
import ApplicationsFilter from '../../sections/employee/applications/ApplicationsFilters';
import RowActions from '../../sections/employee/applications/RowActions';
import ApplicationsProvider, { useApplication } from '../../sections/employee/applications/ApplicationsContext';

export const Applications = () => (
  <Page title="Aplikacje">
    <ApplicationsProvider>
      <TableView
        sidebarActions={getSidebarActions()}
        dataGridProps={getDataGridProps()}
        FilterComponent={ApplicationsFilter}
        RowActionsComponent={RowActions}
        useCtx={useApplication}
        showStatePanel={true}
      />
    </ApplicationsProvider>
  </Page>
);
